import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Message, MessageBox } from 'element-ui';
import util from '@/libs/util.js';
import router from '@/router';
import api from '@/api';
import store from '@/store/index';
import watermark from "@/utils/watermark";
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref, formData) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve, reject) {
          var formatRoutes;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  formatRoutes = function formatRoutes(routes) {
                    routes.forEach(function (route) {
                      route.path = route.url;
                      var paths = route.path ? route.path.split('/') : null;
                      route.name = paths ? paths[paths.length - 1] : '';
                      route.meta = {
                        title: route.title,
                        cache: true
                      };
                      route.children = route.son_menu || [];

                      if (route.son_menu.length) {
                        formatRoutes(route.son_menu);
                      }

                      delete route.son_menu;
                      delete route.url;
                    });
                  };

                  api.login(formData).then( /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
                      var userInfo;
                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (!(res.code == 200)) {
                                _context.next = 16;
                                break;
                              }

                              util.cookies.set('token', res.data.token);
                              res.data.menu.map(function (i) {
                                i.topLevel = true;
                              });
                              formatRoutes(res.data.menu); // 设置路由

                              _context.next = 6;
                              return store.dispatch('d2admin/db/set', {
                                dbName: 'sys',
                                path: 'menu.accessMenus',
                                value: res.data.menu,
                                user: true
                              }, {
                                root: true
                              });

                            case 6:
                              _context.next = 8;
                              return api.getInfo();

                            case 8:
                              userInfo = _context.sent;
                              _context.next = 11;
                              return dispatch('d2admin/user/set', {
                                name: userInfo.data.info.nickname,
                                isLogin: true
                              }, {
                                root: true
                              });

                            case 11:
                              _context.next = 13;
                              return dispatch('load');

                            case 13:
                              resolve(res);
                              _context.next = 18;
                              break;

                            case 16:
                              Message({
                                message: res.msg,
                                type: 'error',
                                duration: '1000'
                              });
                              reject(err);

                            case 18:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x3) {
                      return _ref3.apply(this, arguments);
                    };
                  }()).catch(function (err) {
                    reject(err);
                  });

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 退出用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout: function logout(_ref4) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref5$confirm = _ref5.confirm,
          confirm = _ref5$confirm === void 0 ? false : _ref5$confirm;

      /**
       * @description 退出
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认


      function _logout() {
        _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  watermark.set(""); // 删除cookie

                  util.cookies.remove('token');
                  util.cookies.remove('uuid');
                  store.commit('d2admin/permission/setFet', false);
                  _context3.next = 6;
                  return dispatch('d2admin/page/closeAll', {}, {
                    root: true
                  });

                case 6:
                  _context3.next = 8;
                  return dispatch('d2admin/user/set', {}, {
                    root: true
                  });

                case 8:
                  store.dispatch('d2admin/db/set', {
                    dbName: 'sys',
                    path: 'menu.accessMenus',
                    value: [],
                    user: true
                  }, {
                    root: true
                  }); // 跳转路由

                  router.push({
                    name: 'login'
                  });

                case 10:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return _logout.apply(this, arguments);
      }

      if (confirm) {
        commit('d2admin/gray/set', true, {
          root: true
        });
        MessageBox.confirm('确定要退出当前登录吗', '退出登录', {
          type: 'warning'
        }).then(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          logout();
        }).catch(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          Message({
            message: '取消退出操作',
            duration: '1000'
          });
        });
      } else {
        logout();
      }
    },

    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load: function load(_ref6) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var dispatch;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch = _ref6.dispatch;
                _context4.next = 3;
                return dispatch('d2admin/user/load', null, {
                  root: true
                });

              case 3:
                // // 加载游戏类型
                // await dispatch('d2admin/init/load', null, {
                //   root: true
                // })
                if (util.cookies.get("token")) {
                  watermark.set("无人机竞速管理后台" + store.state.d2admin.user.info.name);
                } // 加载主题


                _context4.next = 6;
                return dispatch('d2admin/theme/load', null, {
                  root: true
                });

              case 6:
                _context4.next = 8;
                return dispatch('d2admin/transition/load', null, {
                  root: true
                });

              case 8:
                _context4.next = 10;
                return dispatch('d2admin/page/openedLoad', null, {
                  root: true
                });

              case 10:
                _context4.next = 12;
                return dispatch('d2admin/menu/asideLoad', null, {
                  root: true
                });

              case 12:
                _context4.next = 14;
                return dispatch('d2admin/size/load', null, {
                  root: true
                });

              case 14:
                _context4.next = 16;
                return dispatch('d2admin/color/load', null, {
                  root: true
                });

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};